import React from 'react'
import PropTypes from 'prop-types'
import styles from './Layout.module.scss'
// import TopNavigation from '../../organisms/TopNavigation/TopNavigation'
// import Sidebar from '../../organisms/Sidebar/Sidebar'
import links from '../Sidebar/Links'
import { useLocation } from 'react-router-dom'
import UserSettings from './UserSettings'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
function TemplatesContainer({ children }) {
  const { t } = useTranslation()
  const location = useLocation()
  const auth = useSelector((state) => state.auth)
  const { profile } = auth?.user || {}
  const isAdmin = profile?.role === 'admin'
  const currentHeaderData = t && links(isAdmin, t)?.find((link) => location.pathname?.includes(link.path))
  return (
    <main className={`${styles.content}`}>
      {currentHeaderData && (
        <section className={styles.header}>
          <div className={`${styles.header_container_text} ${styles[currentHeaderData?.path]}`}>
            {currentHeaderData?.icon}
            <h2 className={styles.text}>{currentHeaderData?.name}</h2>
          </div>
          <UserSettings />
        </section>
      )}
      <section className={styles.page}>{children}</section>
    </main>
  )
}
export default TemplatesContainer

TemplatesContainer.propTypes = {
  children: PropTypes.any.isRequired
}
